import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Logger } from '@app/core/logger.service';
import { ActionSheetController, LoadingController, PopoverController } from '@ionic/angular';
import { TooltipComponent } from '@app/register/tooltip/tooltip.component';
import { environment } from '@env/environment';
import { IonLoaderService } from '@app/shared/services/ion-loader/ion-loader.service';
import { Camera, CameraResultType, Photo } from '@capacitor/camera';
import { UtilitiesService } from '@app/shared/services/utilities/utilities.service';
import { FilesService } from '@app/shared/services/files/files.service';
import { FirebaseService } from '@app/shared/services/firebase/firebase.service';
const log = new Logger('ProfessionalDataFormOpsComponent');
import { Browser } from '@capacitor/browser';
const folderName = 'register-files';
export interface UserData {
  uid: string;
  email: string;
}
@Component({
  selector: 'app-professional-data-form-ops',
  templateUrl: './professional-data-form-ops.component.html',
  styleUrls: ['./professional-data-form-ops.component.scss'],
})
export class ProfessionalDataFormOpsComponent implements OnInit {
  @ViewChild('file', { read: ElementRef, static: true }) file: ElementRef;
  @Input() user: UserData;
  @Output() response = new EventEmitter<void>();
  @Input() button = 'Siguiente';
  public isLoading: boolean;
  specialties: any[];
  public dataFormEsp: FormGroup;
  selectLabel: string = 'Tiempo para finalizar';
  estimatedGraduationTimeOptions = environment.ESTIMATED_GRADUATION_TIME_OPTIONS;
  public educationalLevelOptions: any[] = [
    {
      value: 'estudiante',
      label: 'Estudiante'
    },
    {
      value: 'tecnico',
      label: 'Técnico'
    },
    {
      value: 'universitario',
      label: 'Universitario'
    }
  ];
  public userData: any = {};

  constructor(
    private formBuilder: FormBuilder,
    public popoverCtrl: PopoverController,
    public actionSheetCtrl: ActionSheetController,
    private loader: IonLoaderService,
    private utilities: UtilitiesService,
    private loadingCtrl: LoadingController,
    private filesService: FilesService,
    private fireService: FirebaseService
  ) {
    this.initFormEsp();
  }

  ngOnInit() {
    this.initializeApp();
  }
  async openFile(url: string) {
    await Browser.open({ url });
  }

  async initializeApp() {
    this.isLoading = true;
    this.loader.ionLoaderPresent();
    try {
      await this.initData();
    } catch (error) {
      log.error(error);
    }
    this.loader.ionLoaderDismiss();
    this.isLoading = false;
  }

  public async initData(): Promise<void> {
    try {
      const data1 = await this.fireService.getDoctorData(this.user.uid);
      this.userData = await this.fireService.getUserData(this.user.uid);
      this.refillForm({ ...data1, ...this.userData });
    } catch (error) {
      log.error(error);
    }
  }

  async refillForm(data: any) {
    if (data && data.educationalLevel) {
      await this._onEducationalLevelChange(data.educationalLevel);
      this.dataFormEsp.patchValue({
        cedula: data && data.cedula ? data.cedula : '',
        estimatedGraduationTime: data && data.estimatedGraduationTime ? data.estimatedGraduationTime : '',
        educationalLevel: data && data.educationalLevel ? data.educationalLevel : ''
      });
    }
  }

  async showTooltip(ev: any, text: string) {
    const popover = await this.popoverCtrl.create({
      component: TooltipComponent,
      componentProps: {
        text: text
      },
      event: ev,
      showBackdrop: false,
      cssClass: 'tooltip-popover'
    });

    await popover.present();
  }

  private initFormEsp() {
    this.dataFormEsp = this.formBuilder.group({
      cedula: ['', [Validators.required]],
      verificationFile: [''],
      estimatedGraduationTime: [''],
      educationalLevel: ['']
    });
    this.disableForm(this.dataFormEsp, 'disable');
  }

  async onEducationalLevelChange(event: any) {
    if (event && event.detail && event.detail.value) {
      await this._onEducationalLevelChange(event.detail.value);
    }
  }

  async _onEducationalLevelChange(value: string) {
    await this.later(200);
    switch (value) {
      case 'estudiante':
        // Validadores
        this.dataFormEsp.get('verificationFile').setValidators([Validators.required]);
        this.dataFormEsp.get('cedula').clearValidators();
        this.dataFormEsp.get('estimatedGraduationTime').setValidators([Validators.required]);
        // Valores
        this.dataFormEsp.get('cedula').patchValue('');
        this.dataFormEsp.get('estimatedGraduationTime').patchValue('');
        // Actualizar validez
        this.dataFormEsp.get('verificationFile').updateValueAndValidity();
        this.dataFormEsp.get('estimatedGraduationTime').updateValueAndValidity();
        this.dataFormEsp.get('cedula').updateValueAndValidity();
        break;
      case 'tecnico':
        // Validadores
        this.dataFormEsp.get('verificationFile').setValidators([Validators.required]);
        this.dataFormEsp.get('cedula').clearValidators();
        this.dataFormEsp.get('estimatedGraduationTime').clearValidators();
        // Valores
        this.dataFormEsp.get('cedula').patchValue('');
        this.dataFormEsp.get('estimatedGraduationTime').patchValue('');
        // Actualizar validez
        this.dataFormEsp.get('verificationFile').updateValueAndValidity();
        this.dataFormEsp.get('estimatedGraduationTime').updateValueAndValidity();
        this.dataFormEsp.get('cedula').updateValueAndValidity();
        break;
      case 'universitario':
        // Validadores
        this.dataFormEsp.get('verificationFile').clearValidators();
        this.dataFormEsp.get('cedula').setValidators([Validators.required]);
        this.dataFormEsp.get('estimatedGraduationTime').clearValidators();
        // Valores
        this.file.nativeElement.value = "";
        this.dataFormEsp.get('verificationFile').patchValue('');
        this.dataFormEsp.get('estimatedGraduationTime').patchValue('');
        // Actualizar validez
        this.dataFormEsp.get('verificationFile').updateValueAndValidity();
        this.dataFormEsp.get('estimatedGraduationTime').updateValueAndValidity();
        this.dataFormEsp.get('cedula').updateValueAndValidity();
        break;
    }
  }

  later(delay: number) {
    return new Promise(resolve => {
      setTimeout(resolve, delay);
    });
  }

  async presentActionSheet() {
    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Seleccione una opción',
      buttons: [
        {
          text: 'Cámara',
          handler: () => {
            this.takePicture();
          }
        },
        {
          text: 'Documento',
          handler: () => {
            this.triggerClick1();
          }
        },
        {
          text: 'Cancelar',
          role: 'cancel',
          data: {
            action: 'cancel',
          },
        },
      ],
    });
    await actionSheet.present();
  }

  onSelectOpen() {
    this.selectLabel = 'Tiempo para finalizar estudios';
  }

  onSelectClose() {
    this.selectLabel = 'Tiempo para finalizar';
  }

  disableForm(form: FormGroup<any>, action: 'disable' | 'enable') {
    if (action === 'disable') {
      form.disable();
    } else {
      form.enable();
    }
  }

  public async submit() {
    // ⬅️ INICIO DEL LOADER
    const loader = await this.loadingCtrl.create({
      message: 'Registrando...',
      spinner: 'crescent'
    });
    await loader.present();
    // ⬅️ FIN: loader inicia antes de todo

    this.isLoading = true;
    this.disableForm(this.dataFormEsp, 'disable');

    try {
      const DATA: any = { ...this.dataFormEsp.value };
      let finaData: any = {}
      finaData.educationalLevel = DATA.educationalLevel;
      if (DATA.educationalLevel === 'estudiante') {
        finaData.verificationFileUrl = await this.uploadFile(DATA.verificationFile);
        finaData.estimatedGraduationTime = DATA.estimatedGraduationTime;
        await this.fireService.updateUser(this.user.uid, finaData);
      } else if (DATA.educationalLevel === 'tecnico') {
        finaData.verificationFileUrl = await this.uploadFile(DATA.verificationFile);
        await this.fireService.updateUser(this.user.uid, finaData);
      } else if (DATA.educationalLevel === 'universitario') {
        finaData.cedula = DATA.cedula;
        await this.fireService.updateDoctor(this.user.uid, {
          cedula: String(finaData.cedula).trim()
        });
      }
      this.response.emit();
    } catch (error) {
      log.error(error);
    }

    this.disableForm(this.dataFormEsp, 'enable');
    this.isLoading = false;

    // ⬅️ FINAL: cerrar loader pase lo que pase
    await loader.dismiss();
  }

  public async takePicture() {
    this.isLoading = true;
    await this.loader.ionLoaderPresent();
    try {
      const image: Photo = await Camera.getPhoto({
        quality: 100,
        allowEditing: false,
        resultType: CameraResultType.DataUrl,

      });
      this.dataFormEsp.get('verificationFile').markAsTouched();
      this.dataFormEsp.get('verificationFile').patchValue(image);
      this.dataFormEsp.get('verificationFile').updateValueAndValidity();
    } catch (error) {
      log.error(error);
    }
    await this.loader.ionLoaderDismiss();
    this.isLoading = false;
  }

  triggerClick1() {
    try {
      this.file.nativeElement.click();
    } catch (error) {
      log.error(error);
    }
  }

  async selectFile(data: any) {
    this.isLoading = true;
    await this.loader.ionLoaderPresent();
    try {
      const file: FileList = data.files as FileList;
      this.dataFormEsp.get('verificationFile').markAsTouched();
      this.dataFormEsp.get('verificationFile').patchValue(file);
      this.dataFormEsp.get('verificationFile').updateValueAndValidity();
    } catch (error) {
      this.utilities.toast('Ha ocurrido un error. Inténtelo más tarde.', '¡Ups!');
      log.error(error);
    }
    await this.loader.ionLoaderDismiss();
    this.isLoading = false;
  }

  async uploadFile(file: any): Promise<string> {
    try {
      // folderName
      if (file.dataUrl) {
        const response: any = await this.filesService.uploadImageChatFromCamera(file, folderName);
        return response && response.main && response.main.url ? response.main.url : null;
      } else {
        const response: any = await this.filesService.selectAnyFile(file, folderName, ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png']);
        return response && response.main && response.main.url ? response.main.url : null;
      }
    } catch (error) {
      log.error(error);
      return null
    }
  }
}
